<div class="container-fluid diary-entry" *ngIf="isGenericAprCase">
  <mat-tab-group #tabs mat-align-tabs="start">
    <mat-tab>
      <ng-template mat-tab-label class="heading">
        Generic Approval
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <mat-stepper
    linear
    #stepper
    [(selectedIndex)]="selectedIndex"
    (selectionChange)="onStepChange($event)"
  >
    <form [formGroup]="expForm">
      <mat-step [stepControl]="expForm">
        <ng-template matStepLabel>
          {{ "generic_approval.Basic Details" | translate }}</ng-template
        >
        <div class="row dg-form-row">
          <div class="col-md-6">
            <mat-form-field class="w-100 mt-3">
              <mat-label class="required-field"
                >{{ "generic_approval.Subject" | translate }}
              </mat-label>
              <textarea
                class="text-area"
                matInput
                formControlName="subject"
                [rows]="2"
                cdkTextareaAutosize
                style="overflow: hidden"
              ></textarea>

              <mat-error *ngIf="expForm?.controls?.subject?.errors?.maxlength">
                {{
                  "generic_approval.Maximum characters allowed is 100"
                    | translate
                }}
              </mat-error>
              <mat-error *ngIf="expForm?.controls?.subject?.errors?.required"
                >Please enter Subject</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="row dg-form-row">
          <div class="col-md-6">
            <mat-form-field class="w-100">
              <mat-label class="required-field"
                >{{ "generic_approval.Background/Justification" | translate }}
              </mat-label>
              <textarea
                class="text-area"
                matInput
                formControlName="background"
                [rows]="2"
                cdkTextareaAutosize
                style="overflow: hidden"
              ></textarea>
              <mat-error
                *ngIf="expForm?.controls?.background?.errors?.maxlength"
              >
                {{
                  "generic_approval.Maximum characters allowed is 2000"
                    | translate
                }}
              </mat-error>
              <mat-error *ngIf="expForm?.controls?.background?.errors?.required"
                >Please enter Background/Justification</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="w-100">
              <mat-label class="required-field">
                {{ "generic_approval.Proposed " | translate }}</mat-label
              >
              <textarea
                class="text-area"
                matInput
                formControlName="transaction"
                [rows]="2"
                cdkTextareaAutosize
                style="overflow: hidden"
              ></textarea>
              <mat-error
                *ngIf="expForm?.controls?.transaction?.errors?.maxlength"
              >
                {{
                  "generic_approval.Maximum characters allowed is 2000"
                    | translate
                }}
              </mat-error>
              <mat-error
                *ngIf="expForm?.controls?.transaction?.errors?.required"
                >Please enter Proposed</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="row dg-form-row">
          <div class="col-md-6">
            <mat-form-field>
              <mat-label class="required-field">
                {{ "generic_approval.Budget/Cost involved" | translate }}
              </mat-label>

              <textarea
                class="text-area"
                matInput
                formControlName="budget"
                [rows]="2"
                cdkTextareaAutosize
                style="overflow: hidden"
              ></textarea>
              <mat-error *ngIf="expForm?.controls?.budget?.errors?.maxlength">
                {{
                  "generic_approval.Maximum characters allowed is 500"
                    | translate
                }}
              </mat-error>
              <mat-error *ngIf="expForm?.controls?.budget?.errors?.required">
                Please enter Budget/Cost involved
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field>
              <mat-label class="required-field">
                {{ "generic_approval.Annexures" | translate }}
              </mat-label>
              <textarea
                class="text-area"
                matInput
                formControlName="nature"
                [rows]="2"
                cdkTextareaAutosize
                style="overflow: hidden"
              ></textarea>

              <mat-error *ngIf="expForm?.controls?.nature?.errors?.maxlength">
                {{
                  "generic_approval.Maximum characters allowed is 500"
                    | translate
                }}
              </mat-error>
              <mat-error *ngIf="expForm?.controls?.nature?.errors?.required"
                >Please enter Nature of Document</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div>
          <dg-file-upload
            class="file-upload"
            [multiple]="true"
            [title]="'Supporting Documents'"
            [docTypeCode]="'CASES'"
            [isPreview]="true"
            [isComments]="true"
            [allowMerging]="false"
            [mandatory]="false"
            [attachSmall]="true"
            (finalPath)="onFinalPath($event)"
          >
          </dg-file-upload>
        </div>

        <div class="action-icon align-icon mt-3">
          <button
            color="primary"
            mat-raised-button
            (click)="onNextStep(1)"
            class="actions-button"
            [disabled]="expForm.invalid"
          >
            {{ "dg-publish-config.Proceed" | translate }}
          </button>
        </div>
      </mat-step>

      <mat-step [stepControl]="expForm">
        <div class="col-md-4">
          <mat-form-field>
            <mat-label
              >{{ "generic_approval.Name of Initiator" | translate }}
            </mat-label>
            <input
              matInput
              id="name"
              type="text"
              formControlName="name"
              [maxLength]="100"
            />
          </mat-form-field>
        </div>

        <ng-template matStepLabel
          >{{ "generic_approval.Name of Initiator" | translate }}
        </ng-template>
        <ng-container
          *ngTemplateOutlet="genericApproverHierarchyConfig"
        ></ng-container>
      </mat-step>
    </form>
  </mat-stepper>
</div>
<div *ngIf="!isGenericAprCase">
  <ng-container
    *ngTemplateOutlet="genericApproverHierarchyConfig"
  ></ng-container>
</div>
<ng-template #genericApproverHierarchyConfig>
  <button
    color="primary"
    mat-raised-button
    class="actions-button ms-2 mb-2"
    (click)="openEmpDialog()"
  >
    {{ "generic_approval.Hierarchy selection" | translate }}
  </button>
  <dg-employee-search
    [empConfig]="empConfig"
    [orgConfig]="orgConfig"
    (output)="getData2($event)"
    hidden
  >
  </dg-employee-search>

  <dynamic-grid
    [rows]="accessRows"
    [cols]="accessCols"
    [pageSize]="pageSize"
    [addRowAtTop]="addRowAtTop"
    [showSearch]="false"
    [gridFooterActions]="actionList"
    [colPropConfig]="colPropConfig"
    [canAddRow]="false"
    (onInputChange)="onInputChange($event)"
    (onActionPerformed)="onAccessActionPerformed($event)"
    (onCustomComponentOutput)="onCustomOutput($event)"
    [pinColumn]="undefined"
  >
  </dynamic-grid>
  <div class="action-icon align-icon">
    <button mat-raised-button (click)="onNextStep(0)" class="actions-button">
      {{ "dg-publish-config.Back" | translate }}
    </button>
    <button
      color="primary"
      mat-raised-button
      class="actions-button ms-2"
      (click)="onSave()"
    >
      {{ "generic_approval.Create" | translate }}
    </button>
    <!-- <button
      color="primary"
      mat-raised-button
      class="actions-button ms-2"
      [disabled]="this.accessRows?.length == 0"
      (click)="onSubmit()"
    >
      Submit
    </button> -->
  </div>
</ng-template>
